// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3nZ1H","header":"ClearentDisclaimer_header__3D05I","inner":"ClearentDisclaimer_inner__3hQnV"};